import React, { useState, useEffect, Suspense } from 'react';

// ** Router Import
import Router from './router/Router';

// ** Routes & Default Routes
import { getRoutes } from './router/routes';

// ** Hooks Imports
import { useLayout } from '@hooks/useLayout';
import { useQuery } from '@apollo/client';
import { getProfile } from './graphql/Query/index';
import { handleLogout, handleUserUpdate } from '@store/authentication';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import 'moment/locale/es'; // without this line it didn't work
import { useNavigate } from 'react-router-dom';

moment.locale('es');

const App = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [allRoutes, setAllRoutes] = useState([]);
  const {
    auth: { userData }
  } = useSelector((state) => state);
  // ** Hooks
  const { layout } = useLayout();

  const { stopPolling, startPolling } = useQuery(getProfile, {
    onError: ({ networkError, graphQLErrors }) => {
      if (graphQLErrors[0]) {
        const error = graphQLErrors[0].extensions;
        if (
          error.code === 'UNAUTHENTICATED' &&
          error.response.statusCode === 401
        ) {
          if (userData?.accessToken) {
            dispatch(handleLogout());
          }
        }
      }
      if (networkError) {
        navigate({
          pathname: '/error'
        });
      }
    },
    onCompleted: (data) => {
      dispatch(
        handleUserUpdate({
          ...userData,
          fullName: data.me.fullName,
          email: data.me.email,
          permissions: data.me.permissions
        })
      );
    },
    skip: !userData?.accessToken
  });

  useEffect(() => {
    if (userData?.accessToken) {
      startPolling(100000000000);
    }
    return () => stopPolling();
  }, [startPolling, stopPolling]);

  useEffect(() => {
    setAllRoutes(getRoutes(layout));
  }, [layout]);

  return (
    <Suspense fallback={null}>
      <Router allRoutes={allRoutes} />
    </Suspense>
  );
};

export default App;
